/**
 * White-label single source of truth (PLAN §6, MANDATE #2).
 *
 * A firm re-skins the ENTIRE product — header name, document.title, footer,
 * and theme colors — by editing this one file. Colors here are consumed as
 * CSS custom properties (see BrandProvider + styles/tokens.css), so the
 * brand.config → CSS-variable contract is fixed by the `--brand-*` keys below.
 */
export interface BrandConfig {
  /** Product name — rendered in the header and used for document.title. */
  name: string;
  /** Short positioning line shown under the name. */
  tagline: string;
  /** Legal footer text (firm name, license, copyright). */
  legalFooter: string;
  /** BCP-47 locale used for number/currency/date formatting. */
  locale: string;
  /** Brand colors. Each key maps to a `--brand-<key>` CSS variable. */
  colors: {
    primary: string;
    accent: string;
    surface: string;
    text: string;
  };
}

export const brand: BrandConfig = {
  name: "Ledgerline",
  tagline: "The always-tie-out ledger for UAE multi-entity finance teams.",
  legalFooter: "© 2026 Ledgerline. All figures in AED unless noted.",
  locale: "en-AE",
  colors: {
    primary: "#0f5132",
    accent: "#1a7f5a",
    surface: "#f7f9f8",
    text: "#0b1f17",
  },
};
